// @mui
import { styled } from "@mui/material/styles";
import {
  Box,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
} from "@mui/material";
// components
import Page from "./Page";
// assets
import { AccessTime as TimeIcon } from "@mui/icons-material";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
}));

const InfoContainer = styled(Card)(({ theme }) => ({
  backdropFilter: "blur(10px)",
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(4),
  borderRadius: 16,
  boxShadow: theme.shadows[4],
  marginTop: theme.spacing(3),
  textAlign: "center",
}));

export default function NotAllowedTime({ allowedStart, allowedEnd }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Page title="Access Not Allowed" sx={{ height: 1 }}>
      <RootStyle>
        <Container maxWidth="sm">
          <Box textAlign="center">
            <TimeIcon sx={{ fontSize: isMobile ? 50 : 70, color: "warning.main", mb: 2 }} />
            <Typography variant={isMobile ? "h5" : "h4"} gutterBottom fontWeight="bold">
              ⏰ Access Restricted
            </Typography>

            <Typography sx={{ color: "text.secondary", mb: 2 }}>
              The system is not accessible at this time. Please try again during the allowed hours.
            </Typography>

            <InfoContainer>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Allowed System Access Time:
              </Typography>
              <Typography variant="h6" color="primary.main">
                {allowedStart} – {allowedEnd}
              </Typography>
            </InfoContainer>

            <Typography sx={{ mt: 4, color: "text.secondary", fontSize: 14 }}>
              For urgent assistance, contact:
              <Box component="span" fontWeight="medium" color="text.primary">
                {" "}
                <a href="mailto:ict@oag.gov.so" style={{ textDecoration: 'none', color: 'inherit' }}>
                  ict@oag.gov.so
                </a>
              </Box>{" "}
              or WhatsApp{" "}
              <Box component="span" fontWeight="medium" color="text.primary">
                +252 770569563
              </Box>.
            </Typography>
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
}
